import { z } from 'zod';
import { DeepRequired } from '../../../utils';
import { extendApi } from '../../openapi';

export const publicIdentity = extendApi(
  z.object({
    kind: z.string().min(1),
    value: z.string().min(1),
  }),
  {
    description: 'Identity of a member',
    example: {
      kind: 'email',
      value: 'john.doe@example.com',
    },
  },
);

export type PublicIdentity = DeepRequired<z.infer<typeof publicIdentity>>;
